import SvgIcon from "./SvgIcon";

export default function BadmintonIcon({
  width = "24",
  height = "24",
  color = "#000"
}) {
  return (
    <SvgIcon width={width} height={height}>
      <path
        d="M17.95 16.12l-.38.38-6.15-6.15c.58-.8.88-1.75.82-2.81-.09-1.8-1.15-3.69-2.83-5.07-2.15-1.76-5-1.74-6.78.04C.85 4.29.83 7.14 2.59 9.29c1.38 1.68 3.27 2.74 5.06 2.83h.25c.96 0 1.83-.29 2.56-.83l6.15 6.15-.44.44L21 22.71l1.77-1.77-4.83-4.83.01.01zM7.72 10.78c-1.42-.07-2.95-.94-4.09-2.33-1.33-1.63-1.35-3.67-.04-4.97.67-.67 1.48-.95 2.3-.95.96 0 1.93.39 2.67.99 1.39 1.14 2.27 2.67 2.34 4.09.04.91-.25 1.71-.86 2.32-.61.61-1.41.9-2.32.86v-.01z"
        fill={color}
      />
    </SvgIcon>
  )
}
